import { type FC } from 'react';
import {
  Broadcast
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconBroadcastProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconBroadcast: FC<UiIconBroadcastProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Broadcast}
      {...props}
    />
  );
};
